export default "__VITE_ASSET__BiHqHToX__"